import React from 'react';
import {DialogTypes} from 'common/names';
import Dialog from 'components/Dialog';
import {PermissionsForm} from 'features/layout/DialogRoutes/dialogs/settings/PermissionsDialog/PermissionsForm';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {useTranslation} from 'react-i18next';

type Props = {
   onClose: (result?: string) => void;
   data: INav;
};
export const PermissionsDialog = ({onClose, data}: Props) => {
   const {t} = useTranslation();

   return (
      <Dialog
         maxWidth="md"
         header={t('Permissions for {{name}}', {name: data.name})}
         close={onClose}
      >
         <PermissionsForm onClose={onClose} data={data} />
      </Dialog>
   );
};
